import xlsx from 'json-as-xlsx';
import moment from 'moment';
import insertIf from '../../utils/insertIf';

const CuentasListExport = (data, coopName = '', etiquetaParcela = '', etiquetaPlanta = '') => {
  let xlsData = [
    {
      sheet: 'Productores',
      columns: [
        { label: 'CLAVE', value: 'clave_tx' },
        { label: 'CÓDIGO', value: 'codigo_tx' },
        { label: 'NOMBRE PRODUCTOR', value: 'nombre' },
        { label: 'REGIÓN', value: 'cuenta_region' },
        { label: 'MUNICIPIO', value: 'municipio' },
        { label: 'COMUNIDAD', value: 'localidad' },
        { label: 'CATEGORÍA', value: 'cuenta_categoria' },
        { label: 'No F. SIC', value: row => +row.total_tx_sic },
        { label: 'No REPORTES EXTRAS', value: row => +row.total_r_extras },
        { label: `No ${etiquetaParcela}`, value: row => +row.total_parcelas },
        ...insertIf(etiquetaPlanta, { label: `No ${etiquetaPlanta}`, value: row => +row.total_plantas }),
        { label: 'CICLO', value: 'ciclo' },
        { label: 'EN PADRÓN', value: 'organico' },
        { label: 'PERTENECE A LA ORGANIZACIÓN', value: 'pertenece_cooperativa' },
      ],
      content: data,
    },
  ];

  let settings = {
    fileName: `${moment().format('YYYY')}_${moment().format('MM')}_${moment().format(
      'DD'
    )}_${coopName}_listado_productores_${moment().format('HHmmss')}`,
  };
  xlsx(xlsData, settings);
};

export default CuentasListExport;
